export default "__VITE_ASSET__d6915f22__"